import JQueryView, { on } from '../../../../../../common/views/jqueryView';
// eslint-disable-next-line
// @ts-ignore
import swal from 'sweetalert';

export default class FormView extends JQueryView {
  isClauseOpened: boolean;
  isReviewOpened: boolean;

  constructor(isClauseOpened: boolean, isReviewOpened: boolean) {
    super('.simple_form');
    this.isClauseOpened = isClauseOpened;
    this.isReviewOpened = isReviewOpened;
  }

  @on({ event: 'click', selector: '#agree_with_clause' })
  onClickClause() {
    this.isClauseOpened = true;
  }

  @on({ event: 'click', selector: '#agree_with_pre_judge' })
  onClickReview() {
    this.isReviewOpened = true;
  }

  @on({ event: 'click', selector: 'input[name="commit"]' })
  onSubmit() {
    if (!this.isClauseOpened && !this.isReviewOpened) {
      swal({
        title: '取引約款および事前審査依頼書の内容をご確認ください',
        confirmButtonColor: '#2196F3',
        animation: false,
      });
      return false;
    } else if (!this.isClauseOpened) {
      swal({
        title: '取引約款の内容をご確認ください',
        confirmButtonColor: '#2196F3',
        animation: false,
      });
      return false;
    } else if (!this.isReviewOpened) {
      swal({
        title: '事前審査依頼書の内容をご確認ください',
        confirmButtonColor: '#2196F3',
        animation: false,
      });
      return false;
    } else {
      return true;
    }
  }
}
